<template>
  <div>
    <section class="mbr-section mbr-parallax-background" id="content5-i" data-rv-view="17"
             style="background-image: url(assets/images/fazenda-732x543.jpg); padding-top: 120px; padding-bottom: 120px;">

      <div class="mbr-overlay" style="opacity: 0.7; background-color: rgb(0, 0, 0);">
      </div>

      <div class="container">
        <h3 class="mbr-section-title display-2">{{ data.certificate }}</h3>
        <div class="lead">
          <div>
            <div>
              <div class="col-md-12 text-center">
                <div class="col-md-4 text-center">
                  <img src="assets/images/certs/cert1.png">
                </div>
                <div class="col-md-4">
                  <img src="assets/images/certs/cert2.png">
                </div>
                <div class="col-md-4">
                  <img src="assets/images/certs/cert3.png">
                </div>
              </div>
<!--              <b-card-group deck>-->
<!--                <b-card-->
<!--                    border-variant="BDK"-->
<!--                    header="BDK"-->
<!--                    header-bg-variant="primary"-->
<!--                    header-text-variant="white"-->
<!--                    align="center"-->
<!--                    bg-variant="success"-->
<!--                >-->
<!--                  <a target="_blank" href="downloads/bdk-pt-br.pdf" squared-->
<!--                     variant="primary">-->
<!--                    <b-card-text>-->
<!--                      <div class="space-md">Kashrut</div>-->
<!--                      <i class="socicon icon-download"></i>-->
<!--                    </b-card-text>-->
<!--                  </a>-->


<!--                </b-card>-->
<!--                <b-card-->
<!--                    border-variant="FSSC"-->
<!--                    header="FSSC"-->
<!--                    header-bg-variant="primary"-->
<!--                    header-text-variant="white"-->
<!--                    align="center"-->
<!--                    bg-variant="success"-->
<!--                >-->
<!--                  <div target="_blank" href="" squared-->
<!--                       variant="primary">-->
<!--                    <b-card-text>-->
<!--                      <div class="space-md">FSSC 22000</div>-->
<!--                      &lt;!&ndash;                      <i class="socicon icon-download"></i>&ndash;&gt;-->
<!--                    </b-card-text>-->
<!--                  </div>-->
<!--                </b-card>-->
<!--                <b-card-->
<!--                    border-variant="IBD"-->
<!--                    header="IBD"-->
<!--                    header-bg-variant="primary"-->
<!--                    header-text-variant="white"-->
<!--                    align="center"-->
<!--                    bg-variant="success"-->
<!--                >-->
<!--                  <div target="_blank" href="" squared-->
<!--                       variant="primary">-->
<!--                    <b-card-text>-->
<!--                      <div class="space-md">IBD – Non GMO</div>-->
<!--                      &lt;!&ndash;                      <i class="socicon icon-download"></i>&ndash;&gt;-->
<!--                    </b-card-text>-->
<!--                  </div>-->
<!--                </b-card>-->

<!--              </b-card-group>-->
            </div>
          </div>
        </div>
      </div>

    </section>
  </div>
</template>

<script>
export default {
  name: "Hero",
  props: {
    msg: String
  },
  data() {
    return {
      language: {},
      data: '',
      pt: {
        certificate: 'Certificações'
      },
      en: {
        certificate: 'Certifications'
      },
      es: {
        certificate: 'Certificaciones'
      },
    }
  },
  components: {},
  mounted() {
    if (localStorage.language) {
      this.language = localStorage.language;
    } else {
      localStorage.setItem('language', 'pt')
      document.location.reload(true);
    }
    if (this.language == 'pt') {
      this.data = this.pt;
    }
    if (this.language == 'en') {
      this.data = this.en;
    }
    if (this.language == 'es') {
      this.data = this.es;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.hero {
  padding-top: 7rem;
  width: 100%;
  height: 500px;
  text-align: left;
}

</style>
